import React, { useEffect, useState } from 'react'
import {
  Flex,
  H1WithBack,
  TabsContainer,
  Tabs,
  PageWrapper,
  ContentWrapper,
} from '../../styling/GlobalStyles'
import { AddEmployeerWrapper } from './AddEmployee.styled'
import { EmployeeBasicInfoTab } from './EmployeeBasicInfoTab'
import { EmployeesContractsTab } from './EmployeesContractsTab'
import { NavBar } from '../../components/NavBar/NavBar'
import { EmployeesMachineryTab } from './EmployeesMachineryTab'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { addUser } from 'features/users(Employees)/usersSlice'
import { AppDispatch, RootState } from 'store'
import { toast } from 'react-toastify'
import { EmployeeCapabilitiesTab } from './EmployeeCapabilitiestab'
import { IContract, IEmployee } from 'types/users.interface'
import { employeeBasicInfoTabInputs, employeesInitialState, invalidBankFieldsArray } from './employeesData'
import { EmployeeBankInfoTab } from './EmployeeBankInfoTab'
import { EmployeeWelfareTab } from './EmployeeWelfateTab'

export const AddEmployeer = () => {
  const [active, setActive] = useState('Basic Info')
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()
  const [invalidFields, setInvalidFields] = useState(employeeBasicInfoTabInputs)
  const [invalidBankFields, setInvalidBankFields] = useState(invalidBankFieldsArray)
  const [invalidWelfareFields, setInvalidWelfareFields] = useState([])
  const [state, setState] = useState<IEmployee>({ ...employeesInitialState })
  const { user } = useSelector((state: RootState) => state.user)


  useEffect(() => {
    if (user?.role?.permissions?.contractors) {
      setState(prev => ({ ...prev, accessType: 'contractor' }))
    }
  }, [])

  const handleSubmit = async () => {
    if (invalidFields.length > 0) {
      toast.warn('All basic info fields must be valid')
      return
    }
    const resp = await dispatch(addUser(state))
    if (resp.meta.requestStatus === 'fulfilled') {
      navigate('/hr/employees')
    }
  }

  const renderTabs = () => {
    if (active === 'Basic Info') {
      return (
        <EmployeeBasicInfoTab
          setState={setState}
          state={state}
          setActive={setActive}
          invalidFields={invalidFields}
          setInvalidFields={setInvalidFields}
        />
      )
    } else if (active === 'Bank Info') {
      return <EmployeeBankInfoTab setState={setState} state={state} setActive={setActive} invalidFields={invalidBankFields}
        setInvalidFields={setInvalidBankFields} />
    } else if (active === 'Welfare') {
      return <EmployeeWelfareTab setState={setState} state={state} setActive={setActive} setInvalidFields={setInvalidWelfareFields} invalidFields={invalidWelfareFields} />
    } else if (active === 'Contract') {
      return <EmployeesContractsTab setState={setState} state={state} setActive={setActive} />
    } else if (active === 'Machines') {
      return <EmployeesMachineryTab setState={setState} state={state} setActive={setActive} />
    } else if (active === 'Capabilities') {
      return (
        <EmployeeCapabilitiesTab
          setState={setState}
          state={state}
          setActive={setActive}
          handleSubmit={handleSubmit}
        />
      )
    }
  }

  const changeTab = (name: string) => {
    if (active == 'Contract' && state.contracts.some((c: IContract) => !c.value)) {
      toast.warn('Contracts must be saved first')
    } else if (active == 'Welfare' && invalidWelfareFields.length) {
      toast.warn('Please fill all required fields with valid values before proceeding')
    } else if (active == ' Bank Info' && invalidBankFields.length) {
      toast.warn('Please fill all required fields with valid values before proceeding')
    } else {
      setActive(name)
    }
  }


  return (
    <AddEmployeerWrapper>
      <NavBar />
      <PageWrapper noFooter>
        <Flex between main>
          <H1WithBack arrow title={'Add Employee'} />
          <TabsContainer>
            <Tabs active={active === 'Basic Info'} onClick={() => changeTab('Basic Info')}>
              Basic Info
            </Tabs>
            <Tabs active={active === 'Bank Info'} onClick={() => changeTab('Bank Info')}>
              Bank Info
            </Tabs>
            <Tabs active={active === 'Welfare'} onClick={() => changeTab('Welfare')}>
              Welfare
            </Tabs>
            <Tabs active={active === 'Contract'} onClick={() => changeTab('Contract')}>
              Contract
            </Tabs>
            <Tabs active={active === 'Machines'} onClick={() => changeTab('Machines')}>
              Machines
            </Tabs>
            <Tabs
              active={active === 'Capabilities'}
              onClick={() => changeTab('Capabilities')}
            >
              Capabilities
            </Tabs>
          </TabsContainer>
        </Flex>
        <ContentWrapper noFooter>{renderTabs()}</ContentWrapper>
      </PageWrapper>
    </AddEmployeerWrapper>
  )
}
